/*
 * Store shipping calendar (Europe/Amsterdam wall dates via caller's Date objects):
 * - Ship: Monday–Friday only (no Saturday or Sunday shipments).
 * - Deliver: Monday–Saturday (Saturday allowed); never Sunday (rolls to Monday).
 */
(function () {
  function canShipOn(date) {
    const day = date.getDay();
    return day >= 1 && day <= 5;
  }

  function normalizeShipDay(date) {
    const d = new Date(date);
    while (!canShipOn(d)) {
      d.setDate(d.getDate() + 1);
    }
    return d;
  }

  /** First ship day strictly after `date` (e.g. Picqer restock day). */
  function firstShipDayAfter(date) {
    const d = new Date(date);
    d.setDate(d.getDate() + 1);
    return normalizeShipDay(d);
  }

  /** Delivery = calendar day after ship; Sunday becomes Monday. */
  function deliveryAfterShip(shipDate) {
    const d = new Date(shipDate);
    d.setDate(d.getDate() + 1);
    if (d.getDay() === 0) {
      d.setDate(d.getDate() + 1);
    }
    return d;
  }

  function deliveryFromRestock(restockDate) {
    return deliveryAfterShip(firstShipDayAfter(restockDate));
  }

  /** Order enters fulfillment on `orderStartDate` (same day if before cutoff on a weekday). */
  function deliveryFromOrderStart(orderStartDate) {
    return deliveryAfterShip(normalizeShipDay(orderStartDate));
  }

  function addBusinessDays(amount, from) {
    const date = from ? new Date(from) : new Date();
    let added = 0;

    while (added < amount) {
      date.setDate(date.getDate() + 1);
      const day = date.getDay();
      if (day !== 0 && day !== 6) added++;
    }

    return date;
  }

  function normalizeDeliveryDay(date) {
    const d = new Date(date);
    if (d.getDay() === 0) {
      d.setDate(d.getDate() + 1);
    }
    return d;
  }

  window.ShippingCalendar = {
    canShipOn,
    normalizeShipDay,
    firstShipDayAfter,
    deliveryAfterShip,
    deliveryFromRestock,
    deliveryFromOrderStart,
    addBusinessDays,
    normalizeDeliveryDay,
  };
})();
